import { Action } from '@ngrx/store';

export enum FriendsListActionType {
    LOAD_FRIENDS_LIST = '[Messenger/FriendsList] LOAD_FRIENDS_LIST',
    LOAD_FRIENDS_LIST_FAILED = '[Messenger/FriendsList] LOAD_FRIENDS_LIST_FAILED',
    LOAD_FRIENDS_LIST_SUCCEEDED = '[Messenger/FriendsList] LOAD_FRIENDS_LIST_SUCCEEDED',
    SEARCH_FRIENDS_LIST = '[Messenger/FriendsList] SEARCH_FRIENDS_LIST',
    SEARCH_FRIENDS_LIST_FAILED = '[Messenger/FriendsList] SEARCH_FRIENDS_LIST_FAILED',
    SEARCH_FRIENDS_LIST_SUCCEEDED = '[Messenger/FriendsList] SEARCH_FRIENDS_LIST_SUCCEEDED',
    SEND_FRIEND_REQUEST = '[Messenger/FriendsList] SEND_FRIEND_REQUEST',
    SEND_FRIEND_REQUEST_FAILED = '[Messenger/FriendsList] SEND_FRIEND_REQUEST_FAILED',
    SEND_FRIEND_REQUEST_SUCCEEDED = '[Messenger/FriendsList] SEND_FRIEND_REQUEST_SUCCEEDED',
}


export class LoadFriendsListAction implements Action {
    readonly type = FriendsListActionType.LOAD_FRIENDS_LIST;
    constructor() {}
}

export class LoadFriendsListFailedAction implements Action {
    readonly type = FriendsListActionType.LOAD_FRIENDS_LIST_FAILED;
    constructor(public error: any) {}
}

export class LoadFriendsListSucceededAction implements Action {
    readonly type = FriendsListActionType.LOAD_FRIENDS_LIST_SUCCEEDED;
    constructor(public friends: any) {}
}

export class SearchFriendsListAction implements Action {
    readonly type = FriendsListActionType.SEARCH_FRIENDS_LIST;
    constructor(public query: string) {}
}

export class SearchFriendsListFailedAction implements Action {
    readonly type = FriendsListActionType.SEARCH_FRIENDS_LIST_FAILED;
    constructor(public error: any) {}
}

export class SearchFriendsListSucceededAction implements Action {
    readonly type = FriendsListActionType.SEARCH_FRIENDS_LIST_SUCCEEDED;
    constructor(public friends: any) {}
}

export class SendFriendRequestAction implements Action {
    readonly type = FriendsListActionType.SEND_FRIEND_REQUEST;
    constructor(public userID: string) {}
}

export class SendFriendRequestFailedAction implements Action {
    readonly type = FriendsListActionType.SEND_FRIEND_REQUEST_FAILED;
    constructor(public error: any) {}
}

export class SendFriendRequestSucceededAction implements Action {
    readonly type = FriendsListActionType.SEND_FRIEND_REQUEST_SUCCEEDED;
    constructor(public userID: string) {}
}

export type FriendsListAction
    = LoadFriendsListAction
    | LoadFriendsListFailedAction
    | LoadFriendsListSucceededAction
    | SearchFriendsListAction
    | SearchFriendsListFailedAction
    | SearchFriendsListSucceededAction    
    | SendFriendRequestAction
    | SendFriendRequestFailedAction
    | SendFriendRequestSucceededAction;
